/* eslint-disable jsx-a11y/anchor-is-valid */
import { useCallback, useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AgentLogStatus, ConnectionsViewModel as Model } from 'app/dashboard/model/dashboard.model'
import LoadingSpinner from 'common/partials/LoadingSpinner'
import { DashboardService as Service } from '../../services/dashboard.service'
import i18next from 'i18next'
import en from '../../i18n/en-us.json';
import pt from '../../i18n/pt-br.json';
import es from '../../i18n/es-es.json';
import DashboardContext from 'app/dashboard/context/dashboard.context'
import { useNavigate } from 'react-router-dom'
import { useWebSocket } from 'common/helpers/signalR/context/signalR'

type Props = {
    className: string;
}

export function FailedExecutions(props: Props) {
    i18next.addResourceBundle('us', 'translation', en);
    i18next.addResourceBundle('br', 'translation', pt);
    i18next.addResourceBundle('es', 'translation', es);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const connection = useWebSocket();
    const { dashboardFilters, setFilter } = useContext(DashboardContext);
    const [isLoading, setIsLoading] = useState(false);

    const initialData: Model = {
        active: 0,
        inactive: 0,
        percentActive: 0,
        percentInactive: 0,
        totalQuantity: 0,
    }

    const [failedExecutions, setFailedExecutions] = useState<Model>(initialData);

    const loadFailedExecutions = useCallback(async () => {
        setIsLoading(true);
        const response = await Service.getFailedExecutions();
        if (response && !response.hasErrors) {
            setFailedExecutions(response.data);
        }
        setIsLoading(false);
    }, []);

    useEffect(() => {
        loadFailedExecutions();
        if (!connection) return;
        const listeners: Function[] = [];
        listeners.push(connection.onLoadErrors(loadFailedExecutions));
        return () => listeners.forEach(l => l());
    }, [connection, loadFailedExecutions]);

    const goToHistory = () => {
        navigate(`/processes/robotExecutions?status=${AgentLogStatus.Error}&hasErrorReason=false`);
    }

    return (
        <div
            className={`card ${props.className} ${dashboardFilters.status === AgentLogStatus.Error ? "shadow border border-3 border-primary" : ""} cursor-pointer`}
            style={{ backgroundColor: `${failedExecutions.totalQuantity > 0 ? '#F3D6EF' : undefined}` }}
            onClick={() => setFilter({ ...dashboardFilters, status: dashboardFilters.status === AgentLogStatus.Error ? undefined : AgentLogStatus.Error })}
        >
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-start">
                    {
                        isLoading
                            ? <LoadingSpinner loading={isLoading} align="start" />
                            : <span className="fw-semibold fs-2x text-gray-800 lh-1 ls-n2">{failedExecutions.totalQuantity}</span>
                    }
                    <span><i className={`fa-solid fa-circle-xmark fs-2x ${failedExecutions.totalQuantity > 0 ? 'text-danger' : undefined}`}></i></span>
                </div>
                <div>
                    <span className="fw-semibold fs-6 text-gray-400">{t('failedExecutions.title')}</span>
                </div>
                <div className='position-absolute bottom-0 end-0 me-3'>
                    {failedExecutions.secondCounter && failedExecutions.secondCounter > 0
                        ? <button type='button' className='btn btn-link' onClick={goToHistory}> <i className={`fa-solid fa-triangle-exclamation text-warning`}></i> {`${t('failedExecutions.history')} [${failedExecutions.secondCounter}]`}</button>
                        : <button type='button' className='btn btn-link' onClick={goToHistory}>{t('failedExecutions.history')}</button>
                    }
                </div>
            </div>
        </div >
    )
}